export enum eBulkRateDiscountRule {
  Ineligible = 'INELIGIBLE',
  EligibleByLender = 'ELIGIBLE_BY_LENDER',
}
